export const setLeaderboard = leaders => ( {
	type: 'SETLEADERBOARD',
	payload: leaders
} )